import React from "react"
import types from "prop-types"
import { useSelector } from "react-redux"
import { getFormQuestionAttributeUnitOfMeasure } from "reduxSlices/formBuilderSlice"
import { UNITS_OF_MEASURE } from "utils/dateDifferenceHelpers"
import FormsyValidation from "shared/FormsyValidation"

// Without a recognized unit the difference cannot be calculated, so membership
// is checked rather than presence alone.
const ValidUnitOfMeasureValidation = ({ sectionIndex, questionIndex }) => {
  const questionUnitOfMeasure = useSelector(getFormQuestionAttributeUnitOfMeasure({ sectionIndex, questionIndex }))

  return (
    <FormsyValidation
      name={`sections[${sectionIndex}].questions[${questionIndex}].validUnitOfMeasure`}
      value={questionUnitOfMeasure}
      validations={{
        validUnitOfMeasure(_model, val) {
          if (UNITS_OF_MEASURE.includes(val)) return true
          return "Must have a unit of measure selected"
        },
      }}
    />
  )
}

ValidUnitOfMeasureValidation.propTypes = {
  sectionIndex: types.number.isRequired,
  questionIndex: types.number.isRequired,
}

export default ValidUnitOfMeasureValidation
